// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"formula"},"nodeName":"g","children":[{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M20 12L20 13.4286L18 16M16 12L16 13.4286L18 16M18 16L16 18.5714L16 20M18 16L20 18.5714V20","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M13 4H4V5.5L10 12L4 18.5V20H13","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-formula')
export default class FormulaIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'formula',
    }
  }
}
